import { Link, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Button } from "./ui/button";
import { Calculator, Cog, LineChart, LogOut, Star, TrendingUp } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const handleLogin = () => {
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};

export default function Navbar() {
    const { user, logout } = useAuth();
    const navigate = useNavigate();

    const linkCls = ({ isActive }) =>
        `text-sm font-medium px-3 py-2 rounded-md transition-colors ${
            isActive ? "text-foreground bg-secondary" : "text-muted-foreground hover:text-foreground"
        }`;

    return (
        <header className="sticky top-0 z-40 w-full border-b border-border bg-background/80 backdrop-blur-xl">
            <div className="mx-auto max-w-[1400px] px-6 lg:px-10 h-16 flex items-center justify-between">
                <Link to="/" className="flex items-center gap-2 group" data-testid="brand-link">
                    <div className="h-8 w-8 rounded-lg bg-primary text-primary-foreground grid place-items-center font-heading font-bold">
                        D
                    </div>
                    <span className="font-heading text-lg font-semibold tracking-tight">
                        Divly<span className="text-primary">.</span>
                    </span>
                </Link>

                {user && (
                    <nav className="hidden md:flex items-center gap-1">
                        <NavLink to="/dashboard" className={linkCls} data-testid="nav-screener">
                            <LineChart className="inline h-4 w-4 mr-1.5 -mt-0.5" />
                            Screener
                        </NavLink>
                        <NavLink to="/watchlist" className={linkCls} data-testid="nav-watchlist">
                            <Star className="inline h-4 w-4 mr-1.5 -mt-0.5" />
                            Watchlist
                        </NavLink>
                        <NavLink to="/calculator" className={linkCls} data-testid="nav-calculator">
                            <Calculator className="inline h-4 w-4 mr-1.5 -mt-0.5" />
                            Calculator
                        </NavLink>
                        <NavLink to="/settings" className={linkCls} data-testid="nav-settings">
                            <Cog className="inline h-4 w-4 mr-1.5 -mt-0.5" />
                            Settings
                        </NavLink>
                    </nav>
                )}

                <div className="flex items-center gap-3">
                    {user ? (
                        <>
                            <div className="hidden sm:flex items-center gap-2" data-testid="user-info">
                                {user.picture ? (
                                    <img src={user.picture} alt="" className="h-8 w-8 rounded-full ring-1 ring-border" />
                                ) : (
                                    <div className="h-8 w-8 rounded-full bg-secondary grid place-items-center text-xs font-semibold">
                                        {(user.name || user.email)[0]?.toUpperCase()}
                                    </div>
                                )}
                                <div className="leading-tight">
                                    <div className="text-sm font-medium">{user.name}</div>
                                    <div className="text-xs text-muted-foreground">{user.email}</div>
                                </div>
                            </div>
                            <Button
                                variant="ghost"
                                size="sm"
                                onClick={async () => { await logout(); navigate("/"); }}
                                data-testid="logout-btn"
                            >
                                <LogOut className="h-4 w-4" />
                                <span className="hidden sm:inline">Logout</span>
                            </Button>
                        </>
                    ) : (
                        <Button onClick={handleLogin} className="rounded-full" data-testid="navbar-login-btn">
                            <TrendingUp className="h-4 w-4" />
                            Sign in
                        </Button>
                    )}
                </div>
            </div>
        </header>
    );
}

export { handleLogin };
